import { render } from "./ks-skills-progressive-bar.vue?vue&type=template&id=2a0e5fb7"
import script from "./ks-skills-progressive-bar.vue?vue&type=script&lang=js"
export * from "./ks-skills-progressive-bar.vue?vue&type=script&lang=js"

import "./ks-skills-progressive-bar.vue?vue&type=style&index=0&id=2a0e5fb7&lang=css"
script.render = render

export default script